Promise.all([import('@meteora-digital/modal')]).then(_ref => {
  let [moduleModal] = _ref;
  const ModalController = moduleModal.default;
  DomObserver.observe('.js-default-pdf', blocks => {
    blocks.forEach(block => {
      // Look for the expand button
      const expandButton = block.querySelector('.js-default-pdf__expand');
      if (!expandButton) return;

      // Create a new modal controller
      const Modal = new ModalController();

      // Get the data-img from the expand button
      const imageSrc = expandButton.getAttribute('data-img');

      // Create a new image with this src
      const image = new Image();
      image.src = imageSrc;

      // Append the image to the modal
      Modal.append(image);

      // When we click the expand button
      expandButton.addEventListener('click', () => {
        // Open the modal
        Modal.open();
      });
    });
  });
}).catch(error => {
  // Handle any errors that occur during import
  console.error('An error occurred while loading the modules:', error);
});